<template>
 	<b-col sm>
      	<label>{{ label }}</label>
		<b-form-group>
			<div class="input-box">
				<b-form-radio v-model="state" value="input"></b-form-radio>
				<b-form-input type="number" v-model="value" class="alternate-numeric-field"></b-form-input>
           </div>
           <b-form-radio v-model="state" value="unknown">nem ismert</b-form-radio>
	      </b-form-group>
	</b-col>
</template>
<script>
const UNKNOWN_STRING = 'nem ismert'

export default {
	name: 'alternate-numeric-field',
	props: ['label', 'property'],
	data() {
		return {
			state: 'input'
		}
	},
	watch: {
		state(value) {			
			this.$store.commit('setFormProperty', { property: this.property, value: this.translateStateValue(value)})
		}
	},
	computed: {
		value: {
			get() {
				const storedValue = this.$store.state.form[this.property]
				if (storedValue == UNKNOWN_STRING) {
					this.state = 'unknown'			
					return ''
				}
				return storedValue
			},
			set(newValue) {
				this.state = 'input'
				this.$store.commit('setFormProperty', { property: this.property, value: newValue})
			}
		}
	},
	methods: {
		translateStateValue(value) {
			if (value == 'unknown') {
				return UNKNOWN_STRING
			} else {
				return this.value
			}
		}
	}	
}
</script>
<style scoped>

label, legend {
  font-weight: bold;
}

.input-box {
  display: inline-flex;
  align-items: center;
}

</style>
